import React from "react";
import CustomDatePickerInput from "./CustomDatePickerInput";
import { toDateOnly } from "../utils/tools";

interface ICustomStudentScheduleDate {
  source: string;
  label?: string;
  referenceSource: any;
  includeDates?: IIncludeDates[];
  excludeDates?: IExcludeDates[];
}

const validateScheduleDate = (referenceSource: any) => {
  if (referenceSource === undefined) {
    return;
  }

  const today = toDateOnly(new Date());
  const earlyStart = toDateOnly(referenceSource.earlyRegistrationStartDate);
  const earlyEnd = toDateOnly(referenceSource.earlyRegistrationEndDate);
  const startDate = toDateOnly(referenceSource.startDate);

  // check if date.time Now inside of early Registration Dates
  // if true, will use startDate academic year as minimum date value
  // else, date.time Now will add 14 days or base on the academic year lateRegMinDaysOffset value.
  if (today >= earlyStart && today <= earlyEnd) {
    return referenceSource.startDate;
  }

  // if date.time Now + days base on the academic year lateRegMinDaysOffset value before lateRegistrationStartDate
  // will use lateRegistrationStartDate as minimum date value
  // else will use date.time Now + days base on the academic year lateRegMinDaysOffset value as minimum date value
  if (today < startDate) {
    return referenceSource.lateRegistrationStartDate;
  }

  // Today + offset
  const lateRegMinDaysOffset = referenceSource.lateRegMinDaysOffset ?? 14;
  const offset = new Date(today);
  offset.setDate(offset.getDate() + lateRegMinDaysOffset);
  offset.setHours(0, 0, 0, 0);

  return offset;
};

const disabledInput = (referenceSource: any) => {
  if (referenceSource === undefined) {
    return true;
  }

  let now = new Date();
  now.setDate(now.getDate() + 11);

  // input will disable when date.time Now + 11 days not in early Registration Date
  if (
    new Date(referenceSource.earlyRegistrationStartDate).getTime() >
    now.getTime()
  ) {
    return true;
  }

  return false;
};

const CustomStudentScheduleDateInput = ({
  source,
  label,
  referenceSource,
  includeDates,
  excludeDates,
}: ICustomStudentScheduleDate) => {
  return (
    <>
      <CustomDatePickerInput
        name={source}
        label={label}
        min={validateScheduleDate(referenceSource)}
        max={referenceSource ? referenceSource.endDate : ""}
        disableValue={disabledInput(referenceSource)}
        placeholderValue={
          disabledInput(referenceSource) ? "Select Academic Year first." : ""
        }
        includeDates={includeDates}
        excludeDates={excludeDates}
        isWeekDays
      />
    </>
  );
};

export default CustomStudentScheduleDateInput;
